<template>
  <li class="programCard">
    <div class="card-container">
      <router-link to="download.html" style="text-align:center;"  target="_blank">
        <img :src="product.ImageUrl" class="cardBg">
      </router-link>
      <div class="cardContent" style="height:115px;">
        <div class="cardBox">
          <router-link to="download.html" class="title" target="_blank" v-bind:title="product.Title">{{product.Title}}</router-link>
          <div class="detail">
            <span>&yen;{{product.Price}}</span>
            <!-- <span>{{product.SalesVolume}}人购买</span> -->
          </div>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  name: "box",
  //data:{},
  props: ["product"],
  methods: {

  },
  mounted() {

    console.log(this.product)
  }
};
</script>

<style scoped>
.programCard{
    width: 250px;
    /* height: 480px; */
    margin-top: 30px;
    margin-left: 20px;
    line-height: 0;
    display: inline-block;
  }
 .programCard .cardBg{
   width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }
.programCard .cardContent{
    box-sizing: border-box;
    height: 240px;
    padding: 30px 10px 0px;
    background-color: #fff;
    -webkit-transform: translateZ(0px);
  }
  .screen-list .programCard:nth-child(4n+1) {
     margin-right: 0px;
  }
   .programCard .title{
    font-size: 15px;
    letter-spacing: 0.5px;
  }
  .card-container{
    padding-top:10px;
    background-color: #fff;
  }
</style>
